(function ($) {
    'use strict';
    $.holdReady(false);
}(window.jQuery));
